import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Select,
    Box,
    Flex,Image,
    Text,Button,Card,CardBody,SimpleGrid,
    TableContainer,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    
    Textarea,
    TableCaption,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useToast,
    
  } from "@chakra-ui/react";
  import axios from 'axios';
  import {useSelector} from 'react-redux'
  
  import "react-calendar/dist/Calendar.css";
  import Calendar from "react-calendar";
  import React, { useState,useEffect,useRef } from "react";

  
   
    
  import toast from "react-hot-toast";
   
    
   
    
  
    const TableRegister = () => {
      const customerId=localStorage.getItem('customerId')
    console.log(customerId);
    const [roomData,setRoomData]=useState(0);
    const [data,setData]=useState([])
    const [selectedFile, setSelectedFile] = useState(null);
    const[imageURL,setImageURL]=useState(null);
    const [uploading, setUploading] = useState(false);
    const [printData,setPrintData]=useState([])
    const [images,setImages]=useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const cancelRef = useRef();
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
    };
  
  
    // const handleUpload = async () => {
    //   if (!selectedFile) return;
  
    //   setUploading(true);
    //   const params = {
    //     Bucket: 'tdr-hotel',
    //     Key: selectedFile.tableNo,
    //     Body: selectedFile,
    //     ContentType: selectedFile.type,
    //   };
  
    //   try {
    //     const upload = new Upload({
    //       client: s3Client,
    //       params: params,
    //     });
  
    //     upload.on("httpUploadProgress", (progress) => {
    //       console.log(progress);
    //     });
  
    //     await upload.done();
    //     console.log("Upload successful!");
  
    //     const response = await axios.post("https://api.rcb.tdrsoftware.in/get-signed-url", { key: selectedFile.tableNo });
    //     const signedUrl = response.data.url;
        
    //     setImageURL(signedUrl);
    //   } catch (err) {
    //     console.error("Upload failed:", err);
    //   } finally {
    //     setUploading(false);
    //   }
    // };
    console.log(selectedFile?.tableNo,'selectedFile')
    const fetchImages = async (key) => {
      setUploading(true);
  
      try {
        const response = await axios.get('https://api.rcb.tdrsoftware.in/image', {
          params: {
            customerId: customerId,
            key: key // Optional key parameter
          }
        });
        setImages(response.data);
      } catch (err) {
        console.log(err.message);
      } finally {
        setUploading(false);
      }
    };
    const fetchData = async () => {
      try {
          const response = await axios.get(`https://api.rcb.tdrsoftware.in/api/getTableData/${customerId}`);
          setData(response.data.table);
      } catch (error) {
         // toast.error(error.message);
      }
  };
    const fetchData3=async()=>{
      const response= await axios.get(`https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`)
      setPrintData(response.data)
      const rooms = response.data;
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          const imageResponse = await axios.get('https://api.rcb.tdrsoftware.in/image', {
            params: { customerId, key: room.image }
          });
          room.imageUrl = imageResponse.data;
          return room;
        })
      );
    }
    useEffect(()=>{
   fetchData()
    },[customerId])
   
    const handlePost = async () => {
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append('customerId', customerId);
        formData.append('image', selectedFile);  // Ensure the field tableNo is 'image' here
    
        const response = await axios.post("https://api.rcb.tdrsoftware.in/images", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        const data = response.data;
        setImageURL(Object.values(data).join());
        toast.success("Image uploaded successfully");
        console.log(data,'data')
      } catch (err) {
        toast.error(err);
      } finally {
        setUploading(false);
      }
      
    };
    console.log(typeof(imageURL),'imageURL')
  
     
      useEffect(()=>{
      
      // const fetchImages = async () => {
      //   setUploading(true);
        
      //   try {
      //     const response = await axios.get('https://api.rcb.tdrsoftware.in/images', {
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //       params: {
      //         customerId: customerId
      //       }
      //     });
      //     setImages(response.data);
      //     console.log(response.data,'images');
      //   } catch (err) {
      //     console.log(err.message);
      //   } finally {
      //     setUploading(false);
      //   }
      // };
  
      // fetchImages();
      fetchData3()
      },[customerId])
      let room=printData.map((item)=>item.roomType);
      const roomTypes = room[0]?.split(',')?.map(item => item.trim());
      // let rooms=room.map((item)=>item)
      // console.log(rooms)
      //console.log(roomData)
      const [dueAmount, setDueAmount] = useState(0); 
      const [formData, setFormData] = useState({
       tableNo:"",
       ac:"",
       image:"",
       capacity:0
        
        
      });
      const edit = (item) => {
        setIsEditing(true);
        setEditItemId(item._id);
        setFormData({
            tableNo: item.tableNo || "",
            ac: item.ac || "",
            groupName: item.groupName || "", 
            image: item.image || "",
            capacity: item.capacity || 0,
            
        });
       // console.log(item);
    };
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
      const validateForm = () => {
        const requiredFields = [
          "tableNo",
          "ac",
          "capacity"
         
          
          
        ];
    
        for (const field of requiredFields) {
          if (!formData[field]) {
            return false;
          }
        }
        return true;
      };
    
      const handleSubmit =async (e) => {
        e.preventDefault();
        if (!validateForm()) {
          toast.error("Please fill in all required fields.");
          return;
        }
        // Here you can send formData to your backend server or process it further
       
        // Reset form after submission
        
        setFormData({
          tableNo:formData.tableNo,
          ac:formData.ac,
          capacity:formData.capacity,
        image: imageURL,
        
        
        
         
        });
     
        
      };
  
    const handleImageChange = (e) => {
      setFormData({
        ...formData,
        image: e.target.files[0]
      });
    };
    const handleDueFocus = () => {
      setFormData({
        ...formData,
        child: formData.pax - formData.adult,
      });
    };
  
    const save = async (e) => {
      console.log(formData,'formData')
      e.preventDefault();
      if (!validateForm()) {
          toast.error("Please fill in all required fields.");
          return;
      }
      

      try {
          if (isEditing) {
              const response = await axios.put(`https://api.rcb.tdrsoftware.in/api/tableUpdate/${customerId}/${editItemId}`,{data: formData});
              toast.success(response.data.message);
              setIsEditing(false);
              setEditItemId(null);
          } else {
            const updatedFormData = {
              ...formData,
              image: imageURL, // Directly use the updated imageURL here
            };

            
              const response = await axios.post("https://api.rcb.tdrsoftware.in/api/tableRegister", {
                  customerId:customerId, data:updatedFormData
              });
              toast.success(response.data.message);
          }

          setFormData({
             tableNo:"",
             ac:"",
             capacity:0,
             image:""
          });
          fetchData();
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Handle specific error case: Room booking already exists
          toast.error("Table registred with same table number.");
        } else {
          console.error("Error:", error);
          toast.error("Failed to bill room. Please try again later.");
        }
      }
  };
    const handleDelete=async()=>{
      try{
          const response=await axios.delete(`https://api.rcb.tdrsoftware.in/api/deleteTable/${customerId}/${deleteItemId}`);
          toast.success(response.data.message);
          setIsOpen(false)
          fetchData();
      }catch(error){
          toast.error(error.message);
      }
  }
  const openModal = (id) => {
      setDeleteItemId(id);
      setIsOpen(true);
    };
  
    const onClose = () => {
      setIsOpen(false);
      setDeleteItemId(null);
    };
    
 
      return (
        <Box   bg='#f7f7f7 '
        columns={{ sm: 2, md: 4 }}
        spacing='8'
        p='10'
        textAlign='center'
        
        color='black' width='100%' height='fit-content'   >
          
          <FormControl isRequired onSubmit={handleSubmit}>
            <Box display="grid"  gridGap={1} >
              <Flex
                display="flex"
                gap="10px"
                alignItems="center"
                justifyContent="space-evenly"
               
              >
                <Box width="40%"  display="flex" alignItems="center"  boxShadow='xl'
                borderRadius="5px"
                
                p={4}>
                  <FormLabel  >Table No</FormLabel>
                  <Input w='70%' bg='#FAFAFA ' placeholder="Enter table no" border='1px solid #ffe4d9'   name='tableNo' value={formData.tableNo} onChange={handleInputChange} />
                </Box>
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
                borderRadius="5px"
                p={4}>
                  <FormLabel>Ac/Non-Ac</FormLabel>
                  <Select w='70%'  bg='#FAFAFA '  placeholder="Ac/Non-Ac" border='1px solid #ffe4d9' name='ac' value={formData.ac} onChange={handleInputChange} >  
                    <option>Ac</option>
                    <option>Non-Ac</option>
                  </Select>
                </Box>
              </Flex>
              <Box
                display="flex"
                gap="10px"
                alignItems="center"
                justifyContent="space-evenly"
                
              >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
                borderRadius="5px"
                p={4}>
                  <FormLabel>Capacity</FormLabel>
                  <Input w='70%' bg='#FAFAFA ' placeholder="Enter Capacity" name='capacity' value={formData.capacity} onChange={handleInputChange}/>
                
                </Box>
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
                borderRadius="5px"
                p={4}>
                  <FormLabel>Image</FormLabel>
                  <Input w='70%' type="file" bg='#FAFAFA ' onChange={handleFileChange} />
                  <Button variant='solid' onClick={handlePost} disabled={uploading}>
          {uploading ? "Uploading..." : "Upload"}
        </Button>
       
                  
                </Box>
                
              </Box>
              
              
            
              
              
             
                
               
             
             
             
              
              
              
            <hr/>
            <Box display='flex' flexDirection='column' rowGap='10px' mt={4}>
           
                </Box>
  
            </Box>
           
            {/* <Button ac="submit" variant='solid' mr={4} color='white' bg='tomato' _hover={{color:'tomato',bg:'white'}} mt={5} onClick={handleSubmit}>Submit</Button> */}
            <Button ac="submit" variant='solid' color='white' bg='tomato' _hover={{color:'tomato',bg:"white"}} mt={5} onClick={save}>{isEditing ? "Update" : "Save"}</Button>
          </FormControl>
          <TableContainer width='100%' overflowX='auto' mt={10} border='1px solid black' p={4} bg='white' borderRadius='10px' fontSize='sm'>
                <Table size='sm' variant='striped' colorScheme='teal'>
                    <TableCaption>Item Data</TableCaption>
                    <Thead>
                        <Tr >
                            <Th >TableNo</Th>
                            <Th>Ac/Non-Ac</Th>
                            <Th>Capacity</Th>
                            
                            <Th>Edit</Th>
                            <Th>Delete</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.map((item, index) => (
                            <Tr key={index}>
                                <Td>{item.tableNo}</Td>
                                <Td>{item.ac}</Td>
                                <Td>{item.capacity}</Td>
                                
                                <Td><Button colorScheme="green" size="sm" onClick={() => edit(item)}>Edit</Button></Td>
                                <Td><Button colorScheme="red" size="sm" onClick={() => openModal(item._id)}>Delete</Button></Td>

                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
          <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
          
        </Box>
      );
  
    
  
    }
  
  
  
  
  
  export default TableRegister